import { connect } from 'react-redux'

import { setUserVideoAutoPlayStatus } from '../../../../common/actions/user/preference'
import GridVideo from './gridVideo'

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    setUserVideoAutoPlayStatus: status =>
      dispatch(setUserVideoAutoPlayStatus(status))
  }
}

const GridVideoContainer = connect(mapStateToProps, mapDispatchToProps)(
  GridVideo
)

export default GridVideoContainer
